import { handleActions } from "redux-actions";

import { SET_SELECTED_PERIOD, SET_START_DATE, SET_END_DATE } from "./types";
import { PERIODS } from "../../pages/dashboard/constants";

const initState = {
  period: PERIODS[0],
  startDate: new Date(),
  endDate: new Date(),
};

export default handleActions(
  {
    [SET_SELECTED_PERIOD]: (state, { payload }) => {
      return { ...state, period: payload };
    },
    [SET_START_DATE]: (state, { payload }) => {
      return { ...state, startDate: payload };
    },
    [SET_END_DATE]: (state, { payload }) => {
      return { ...state, endDate: payload };
    },
  },
  initState
);
